import { Component, OnInit, NgModule, Input, ViewChild, Type } from '@angular/core';
import { HeaderBaseComponent, HeaderComponent, HeaderPartenaireComponent, SideNavigationMenuModule } from '../../shared/components';
import { AppInfoService, ScreenService } from '../../shared/services';
import { DxTreeViewTypes } from 'devextreme-angular/ui/tree-view';
import { DxDrawerModule } from 'devextreme-angular/ui/drawer';
import { DxScrollViewModule, DxScrollViewComponent } from 'devextreme-angular/ui/scroll-view';
import { CommonModule } from '@angular/common';
import { Router, NavigationEnd, Scroll, RouterModule, Event, NavigationErrorHandlerFeature } from '@angular/router';
import { HeaderDirective } from '../../shared/components/header/header.directive';
import { TypeUtilisateur } from '@lexi-clients/lexi';
import { AuthService } from '../../settings/auth.service';
import { HeaderModule } from '../../shared/components/header/header.module';
import { Subscription } from 'rxjs';
import { AppFooterModule } from '../../shared/components';
@Component({
    selector: 'app-side-nav-outer-toolbar',
    templateUrl: './side-nav-outer-toolbar.component.html',
    styleUrls: ['./side-nav-outer-toolbar.component.scss'],
    standalone: false
})
export class SideNavOuterToolbarComponent implements OnInit {
  @ViewChild(DxScrollViewComponent, { static: true }) scrollView: DxScrollViewComponent;
  @ViewChild(HeaderDirective, { static: true }) headerHost: HeaderDirective;
  routerSubscription: Subscription;
  selectedRoute = '';

  isPartenaire = false;
  menuOpened: boolean;
  temporaryMenuOpened = false;

  @Input()
  title: string;

  menuMode = 'shrink';
  menuRevealMode = 'expand';
  minMenuSize = 0;
  shaderEnabled = false;
  fullScreen = false;

  canShowPiecesNonIntegreesPopup = false;

  constructor(private screen: ScreenService, private router: Router,
    public appInfo: AppInfoService,
    private authService: AuthService) {
    this.routerSubscription = this.router.events.subscribe((event: Event) => {
      if (event instanceof NavigationEnd) {
        this.selectedRoute = event.urlAfterRedirects.split('?')[0];
      }
      else if (event instanceof Scroll) {
        this.selectedRoute = event.routerEvent.url.split('?')[0];
      }
    });
  }

  ngOnInit() {
    this.menuOpened = this.screen.sizes['screen-large'];
    this.toggleMenu(this.menuOpened);

    this.router.events.subscribe(val => {
      if (val instanceof NavigationEnd) {
        const urlParams = new URLSearchParams(val.url);
        const param = urlParams.get('FullScreen');
        if (param) {
          this.fullScreen = true;
        }
        else {
          this.fullScreen = false;
        }
      }
    });

    this.screen.changed.subscribe(() => this.updateDrawer());

    this.updateDrawer();

    this.loadHeader();

    if(this.authService.authenticatedUser.isRoot && this.authService.currentSociete.avecBackOffice){
      this.canShowPiecesNonIntegreesPopup = true;
    }
  }

  loadHeader() {
    // chargement dynamique de component : https://angular.io/guide/dynamic-component-loader
    const components: { [id: string]: Type<HeaderBaseComponent>; } = {};
    components[TypeUtilisateur.collaborateur.toLowerCase()] = HeaderComponent;
    components[TypeUtilisateur.partenaire.toLowerCase()] = HeaderPartenaireComponent;

    let type: Type<HeaderBaseComponent> = components[this.authService.securityUser?.typeUtilisateur];

    const viewContainerRef = this.headerHost.viewContainerRef;
    viewContainerRef.clear();

    const componentRef = viewContainerRef.createComponent(type);
    componentRef.instance.menuToggleEnabled = true;
    componentRef.instance.title = this.title;
    componentRef.instance.menuToggle.subscribe(s => {
      this.menuOpened = !this.menuOpened;
      this.toggleMenu(this.menuOpened);
    });
  }

  toggleMenu(isMenuOpened: boolean): void {
    const body = document.body;
    if (isMenuOpened) {
      body.classList.remove('menu-collapsed');
    } else {
      body.classList.add('menu-collapsed');
    }
  }

  updateDrawer() {
    const isXSmall = this.screen.sizes['screen-x-small'];
    const isLarge = this.screen.sizes['screen-large'];

    this.menuMode = isLarge ? 'shrink' : 'overlap';
    this.menuRevealMode = isXSmall ? 'slide' : 'expand';
    this.minMenuSize = isXSmall ? 0 : 48;
    this.shaderEnabled = !isLarge;
  }

  get hideMenuAfterNavigation() {
    return this.menuMode === 'overlap' || this.temporaryMenuOpened;
  }

  get showMenuAfterClick() {
    return !this.menuOpened;
  }

  navigationChanged(event: DxTreeViewTypes.ItemClickEvent) {
    const path = (event.itemData as any).path;
    const pointerEvent = event.event;

    if (path && this.menuOpened) {
      if (event.node?.selected) {
        pointerEvent?.preventDefault();
      } else {
        this.router.navigate([path]);
      }

      if (this.hideMenuAfterNavigation) {
        this.temporaryMenuOpened = false;
        this.menuOpened = false;
        pointerEvent?.stopPropagation();
        this.toggleMenu(this.menuOpened);
      }
    } else {
      pointerEvent?.preventDefault();
    }
  }

  navigationClick() {
    if (this.showMenuAfterClick) {
      this.temporaryMenuOpened = true;
      this.menuOpened = true;
      this.toggleMenu(this.menuOpened);
    }
  }
}